import React, { useEffect, useState, useMemo } from "react"; // Import useMemo
import SummaryApi from "../common";
import { toast } from "react-toastify";
import { Card, Spin, Row, Col, Badge, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import {
  PhoneOutlined,
  HeartOutlined,
  SmileOutlined,
  CloseCircleOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";

const TeamLeadEmployees = () => {
  const [loading, setLoading] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [teamLeadName, setTeamLeadName] = useState("");
  const navigate = useNavigate();

  // --- State for memberType ---
  const [memberType, setMemberType] = useState(null);

  useEffect(() => {
    // Fetch memberType on component mount
    const encodedMemberType = sessionStorage.getItem('K3M8X1JQ5VZ4B7PWTL9');
    const decodedMemberType = encodedMemberType ? atob(encodedMemberType) : null;
    setMemberType(decodedMemberType);

    const fetchTeamLeadEmployees = async () => {
      try {
        setLoading(true);
        const encodedEmployeeId = sessionStorage.getItem(
          "H7Z4L9VD2XK5JW8QRYT6"
        );
        if (!encodedEmployeeId) {
          toast.error("Employee ID not found. Please log in again.");
          setLoading(false); // Ensure loading is set to false even on error
          return;
        }
        const teamLeadEmpId = atob(encodedEmployeeId);
        const response = await fetch(SummaryApi.TeamLeadEmp.url, {
          method: SummaryApi.TeamLeadEmp.method,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer sandeep_university_916",
          },
          body: JSON.stringify({ team_lead_emp_id: teamLeadEmpId }),
        });

        if (!response.ok) {
          throw new Error("Failed to fetch employee data");
        }

        const data = await response.json();

        if (data?.team_lead_full_name) {
          setTeamLeadName(data.team_lead_full_name);
        }

        if (Array.isArray(data?.data)) {
          setEmployees(data.data);
        } else {
          toast.info("No employees assigned to this Team Lead.");
          setEmployees([]);
        }
      } catch (error) {
        toast.error(`Error: ${error.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchTeamLeadEmployees();
  }, []); // Depend only on memberType if fetching based on it, otherwise empty []

  // --- Helper to check if the user is a Team Lead ---
  const isTeamLead = useMemo(() => memberType === 'Team Lead', [memberType]);


  const handlebackClick = () => {
    navigate(-1);
  };

  return (
    <div style={{ padding: "20px" }}>
      <div className="flex justify-between">
        <h2 className="text-2xl font-bold mb-6">
          Team Lead:{" "}
          <span style={{ color: "#3e0f94" }}>{teamLeadName || "..."}</span>
        </h2>
        {/* Conditionally render the Back button */}
        {!isTeamLead && (
          <button
            onClick={handlebackClick}
            className="bg-blue-600 text-white px-4 py-2 rounded border mb-2"
          >
            Back
          </button>
        )}
      </div>
      {loading ? (
        <div className="flex justify-center items-center h-48">
          <Spin size="large" />
        </div>
      ) : employees.length === 0 ? (
        <p style={{ fontSize: "16px", color: "#555" }}>
          No employees assigned.
        </p>
      ) : (
        <Row gutter={[16, 16]}>
          {employees.map((emp) => (
            <Col xs={24} sm={12} md={8} lg={6} key={emp.assign_emp_id}>
              <Card
                hoverable
                onClick={() => navigate(`/my-employees/${emp.assign_emp_id}`)}
                style={{
                  borderRadius: "10px",
                  border: "1px solid #e0e0e0",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.05)",
                  transition: "transform 0.2s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "scale(1.03)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
                title={
                  <span style={{ color: "#3e0f94", fontWeight: "bold" }} className="flex justify-between">
                    {emp.assign_full_name}
                     <span>{emp.mobile_number || "N/A"}</span>
                  </span>
                }
                // extra={
                //   <Badge
                //     count={emp.total_count}
                //     style={{ backgroundColor: "#52c41a" }}
                //   />
                // }
              >
                {/* <p>
                  <PhoneOutlined style={{ color: "#1890ff", marginRight: 6 }} />
                  <strong>Phone:</strong> {emp.mobile_number || "N/A"}
                </p> */}
                <p>
                  <HeartOutlined style={{ color: "#eb2f96", marginRight: 6 }} />
                  <strong>Most Interested:</strong> {emp.most_interested_count}
                </p>
                <p>
                  <SmileOutlined style={{ color: "#faad14", marginRight: 6 }} />
                  <strong>Interested:</strong> {emp.interested_count}
                </p>
                <p>
                  <CloseCircleOutlined
                    style={{ color: "#ff4d4f", marginRight: 6 }}
                  />
                  <strong>Not Interested:</strong> {emp.not_interested_count}
                </p>
                <p>
                  <QuestionCircleOutlined
                    style={{ color: "#595959", marginRight: 6 }}
                  />
                  <strong>Not Answered:</strong> {emp.not_answered_count}
                </p>
                    <p>
  <PhoneOutlined style={{ color: "#13c2c2", marginRight: 6 }} />
  <strong>Call Back:</strong> {emp.call_back_count}
</p>

              </Card>
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
};

export default TeamLeadEmployees;